import React, { FC, ReactNode, SVGAttributes } from 'react';
import {
  SolidCaretCircleDown,
  SolidCaretCircleLeft,
  SolidCaretCircleRight,
  SolidCaretCircleUp,
  SolidArrowCircleRight,
  SolidArrowCircleLeft,
  SolidArrowCircleUp,
  SolidArrowCircleDown,
  SolidChevronCircleRight,
  SolidChevronCircleLeft,
  SolidChevronCircleUp,
  SolidChevronCircleDown,
  SolidChevronRight,
  SolidChevronLeft,
  SolidChevronUp,
  SolidChevronDown,
  SolidArrowRight,
  SolidArrowLeft,
  SolidArrowUp,
  SolidArrowDown,
  SolidLongArrowRight,
  SolidLongArrowLeft,
  SolidLongArrowUp,
  SolidLongArrowDown,
  SolidAltArrowRight,
  SolidAltArrowLeft,
  SolidAltArrowUp,
  SolidAltArrowDown,
  SolidCaretRight,
  SolidCaretLeft,
  SolidCaretUp,
  SolidCaretDown,
  RegularCircleCaretRight,
  RegularCircleCaretLeft,
  RegularCircleCaretUp,
  RegularCircleCaretDown,
  RegularCircleAltArrowRight,
  RegularCircleAltArrowLeft,
  RegularCircleAltArrowUp,
  RegularCircleAltArrowDown,
  RegularCircleArrowRight,
  RegularCircleArrowLeft,
  RegularCircleArrowUp,
  RegularCircleArrowDown,
  RegularCircleChevronRight,
  RegularCircleChevronLeft,
  RegularCircleChevronUp,
  RegularCircleChevronDown,
  RegularChevronRight,
  RegularChevronLeft,
  RegularChevronUp,
  RegularChevronDown,
  RegularArrowRight,
  RegularArrowLeft,
  RegularArrowUp,
  RegularArrowDown,
  RegularLongArrowRight,
  RegularLongArrowLeft,
  RegularLongArrowUp,
  RegularLongArrowDown,
  RegularLongAltArrowRight,
  RegularLongAltArrowLeft,
  RegularLongAltArrowUp,
  RegularLongAltArrowDown,
  SolidAdIcon,
  SolidBullhorn,
  SolidBars,
  SolidBell,
  SolidSignIn,
  SolidSignOut,
  RegularAdIcon,
  RegularBullhorn,
  RegularBars,
  RegularBell,
  RegularSignIn,
  RegularSignOut,
  RegularAltSignIn,
  RegularAltSignOut,
  SolidAnalytics,
  SolidChartLineUp,
  SolidChartLineDown,
  SolidChartNetwork,
  SolidPieChart,
  SolidBarChart,
  SolidPoll,
  RegularAnalytics,
  RegularChartLineUp,
  RegularChartLineDown,
  RegularChartNetwork,
  RegularPieChart,
  RegularBarChart,
  RegularPoll,
  SolidHome,
  SolidStar,
  SolidHalfStar,
  SolidAltHalfStar,
  SolidMousePointer,
  SolidStreetView,
  RegularHome,
  RegularStar,
  RegularHalfStar,
  RegularBullseyePointer,
  RegularStreetView,
  SolidHorizontalArrows,
  SolidVerticalArrows,
  SolidSort,
  SolidExchange,
  RegularHorizontalArrows,
  RegularVerticalArrows,
  RegularSort,
  RegularExchange,
  RegularAltHorizontalArrows,
  RegularAltVerticalArrows,
  RegularSortDown,
  RegularAltSortDown,
  RegularSortUp,
  RegularAltSortUp,
  SolidLock,
  SolidAltLock,
  SolidOpenLock,
  SolidAltOpenLock,
  SolidAltUnlock,
  SolidUnlock,
  RegularLock,
  RegularAltLock,
  RegularOpenLock,
  RegularAltOpenLock,
  RegularAltUnlock,
  RegularUnlock,
  RegularCreditCard,
  RegularCoins,
  RegularDatabase,
  RegularBill,
  RegularDollarSign,
  RegularCircleDollarSign,
  RegularSearchDollarSign,
  SolidCreditCard,
  SolidCoins,
  SolidDatabase,
  SolidDollarSign,
  SolidSearchDollarSign,
  SolidUsers,
  SolidUsersClock,
  SolidUsersCircle,
  User,
  RegularUsers,
  RegularAltUser,
  RegularUsersChart,
  RegularUsersCircle,
  RegularUsersChalkboard,
  RegularUser,
  HorizontalEllipsis,
  VerticalEllipsis,
  SolidQuestion,
  SolidCircleQuestion,
  SolidCircleExclamation,
  SolidExclamation,
  SolidTriangleExclamation,
  SolidInfoCircle,
  RegularAt,
  RegularCircleQuestion,
  RegularCircleExclamation,
  RegularTriangleExclamation,
  RegularInfoCircle,
  SolidCalendar,
  SolidDayCalendar,
  RegularCalendar,
  SolidCamera,
  SolidPhotoVideo,
  SolidVideo,
  SolidImage,
  RegularCamera,
  RegularPhotoVideo,
  RegularVideo,
  RegularImage,
  RegularAltImage,
  RegularImages,
  SolidPercent,
  SolidPercentage,
  SolidSync,
  SolidAltSync,
  RegularPercent,
  RegularPercentage,
  RegularSync,
  RegularAltSync,
  SolidRoute,
  SolidGlobe,
  SolidMap,
  SolidMapMarker,
  SolidMapPin,
  SolidMapSigns,
  SolidLocation,
  SolidDirections,
  RegularRoute,
  RegularGlobe,
  RegularMap,
  RegularMapMarker,
  RegularMapPin,
  RegularMapSigns,
  RegularLocation,
  RegularDirections,
  SolidCheck,
  SolidCircleCheck,
  SolidDoubleCheck,
  SolidBadgeCheck,
  RegularCheck,
  RegularCircleCheck,
  RegularDoubleCheck,
  RegularMinusSquare,
  RegularCheckSquare,
  RegularSquare,
  SolidRocketLaunch,
  SolidCircleX,
  RegularCircleX,
  RegularX,
  SolidEye,
  SolidEyeSlash,
  RegularEye,
  RegularEyeSlash,
  SolidToggleOn,
  SolidToggleOff,
  RegularToggleOn,
  RegularToggleOff,
  SolidPlus,
  SolidCirclePlus,
  RegularPlus,
  RegularCirclePlus,
  SolidPhone,
  SolidAltPhone,
  SolidLink,
  SolidCog,
  SolidPen,
  SolidTrash,
  SolidAltTrash,
  RegularPhone,
  RegularAltPhone,
  RegularLink,
  RegularCog,
  RegularPen,
  RegularTrash,
  RegularAltTrash,
  SolidReply,
  SolidEdit,
  SolidFilter,
  SolidExternalLink,
  SolidDownload,
  RegularReply,
  RegularEdit,
  RegularFilter,
  RegularExternalLink,
  RegularAltExternalLink,
  RegularDownload,
  SolidShare,
  SolidClock,
  SolidSearch,
  SolidSearchPlus,
  RegularShare,
  RegularClock,
  RegularSearch,
  RegularSearchPlus,
  SolidEnvelope,
  SolidEnvelopeOpen,
  SolidEnvelopeOpenText,
  SolidMailBulk,
  RegularEnvelope,
  RegularEnvelopeOpen,
  RegularEnvelopeOpenText,
  RegularMailBulk,
  SolidSave,
  SolidFolderOpen,
  RegularSave,
  RegularFolderOpen,
  SolidComments,
  RegularComments,
  RegularAltComments,
  RegularComment,
  RegularAltComment,
  SolidCloudUpload,
  SolidCloudDownload,
  RegularCloudUpload,
  RegularCloudDownload,
  SolidTask,
  SolidAltTask,
  RegularList,
  RegularFile,
  RegularFileExport,
  RegularFileImport,
  RegularFileSignature,
  RegularFileInvoiceDollar,
  RegularAltFile,
  RegularLandmark,
  RegularHistory,
  RegularPhoneRotary,
  RegularPhoneOffice,
  RegularPhoneLaptop,
  RegularVoicemail,
  RegularMobile,
  RegularMobileAndroid,
  RegularAward,
  RegularHandshake,
  SolidLandmark,
  SolidHistory,
  SolidPhoneRotary,
  SolidPhoneOffice,
  SolidPhoneLaptop,
  SolidVoicemail,
  SolidMobile,
  SolidMobileAndroid,
  SolidReaction,
  RegularReaction,
  SolidPiggyBank,
  Android,
  Desktop,
  Wifi,
  Bluetooth,
  ThryvLogo,
  ThryvpayLogo,
  RegularHeart,
  SolidHeart,
  CalendarClockIcon,
  RegularClockCalendar,
  MemoCheck,
  RegularMemoCheck,
  Briefcase,
  RegularBriefcase,
  SolidCirclePhone,
} from '../icons';

export interface IconProperties extends SVGAttributes<SVGSVGElement> {
  variant: string;
  type: 'regular' | 'solid';
  height?: string;
  width?: string;
  color?: string;
  children?: ReactNode;
}

export const Icon: FC<IconProperties> = ({
  variant,
  type,
  height,
  width,
  color,
  children,
  ...rest
}: IconProperties) => {
  if (type === 'solid') {
    if (variant === 'circlePhone') {
      return (
        <SolidCirclePhone height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidCirclePhone>
      );
    }
    if (variant === 'briefcase') {
      return (
        <Briefcase height={height} width={width} fill={color} {...rest}>
          {children}
        </Briefcase>
      );
    }
    if (variant === 'memoCheck') {
      return (
        <MemoCheck height={height} width={width} fill={color} {...rest}>
          {children}
        </MemoCheck>
      );
    }
    if (variant === 'heart') {
      return (
        <SolidHeart height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidHeart>
      );
    }
    if (variant === 'reaction')
      return (
        <SolidReaction height={height} width={width} fill={color} {...rest} />
      );
    if (variant === 'caretCircleLeft')
      return (
        <SolidCaretCircleLeft
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidCaretCircleLeft>
      );
    if (variant === 'caretCircleRight')
      return (
        <SolidCaretCircleRight
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidCaretCircleRight>
      );
    if (variant === 'caretCircleUp')
      return (
        <SolidCaretCircleUp
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidCaretCircleUp>
      );
    if (variant === 'caretCircleDown')
      return (
        <SolidCaretCircleDown
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidCaretCircleDown>
      );
    if (variant === 'arrowCircleLeft')
      return (
        <SolidArrowCircleLeft
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidArrowCircleLeft>
      );
    if (variant === 'arrowCircleRight')
      return (
        <SolidArrowCircleRight
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidArrowCircleRight>
      );
    if (variant === 'arrowCircleUp')
      return (
        <SolidArrowCircleUp
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidArrowCircleUp>
      );
    if (variant === 'arrowCircleDown')
      return (
        <SolidArrowCircleDown
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidArrowCircleDown>
      );
    if (variant === 'chevronCircleLeft')
      return (
        <SolidChevronCircleLeft
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidChevronCircleLeft>
      );
    if (variant === 'chevronCircleRight')
      return (
        <SolidChevronCircleRight
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidChevronCircleRight>
      );
    if (variant === 'chevronCircleUp')
      return (
        <SolidChevronCircleUp
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidChevronCircleUp>
      );
    if (variant === 'chevronCircleDown')
      return (
        <SolidChevronCircleDown
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidChevronCircleDown>
      );
    if (variant === 'chevronLeft')
      return (
        <SolidChevronLeft height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidChevronLeft>
      );
    if (variant === 'chevronRight')
      return (
        <SolidChevronRight height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidChevronRight>
      );
    if (variant === 'chevronUp')
      return (
        <SolidChevronUp height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidChevronUp>
      );
    if (variant === 'chevronDown')
      return (
        <SolidChevronDown height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidChevronDown>
      );
    if (variant === 'arrowLeft')
      return (
        <SolidArrowLeft height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidArrowLeft>
      );
    if (variant === 'arrowRight')
      return (
        <SolidArrowRight height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidArrowRight>
      );
    if (variant === 'arrowUp')
      return (
        <SolidArrowUp height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidArrowUp>
      );
    if (variant === 'arrowDown')
      return (
        <SolidArrowDown height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidArrowDown>
      );
    if (variant === 'longArrowLeft')
      return (
        <SolidLongArrowLeft
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidLongArrowLeft>
      );
    if (variant === 'longArrowRight')
      return (
        <SolidLongArrowRight
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidLongArrowRight>
      );
    if (variant === 'longArrowUp')
      return (
        <SolidLongArrowUp height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidLongArrowUp>
      );
    if (variant === 'longArrowDown')
      return (
        <SolidLongArrowDown
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidLongArrowDown>
      );
    if (variant === 'altArrowLeft')
      return (
        <SolidAltArrowLeft height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidAltArrowLeft>
      );
    if (variant === 'altArrowRight')
      return (
        <SolidAltArrowRight
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidAltArrowRight>
      );
    if (variant === 'altArrowUp')
      return (
        <SolidAltArrowUp height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidAltArrowUp>
      );
    if (variant === 'altArrowDown')
      return (
        <SolidAltArrowDown height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidAltArrowDown>
      );
    if (variant === 'caretLeft')
      return (
        <SolidCaretLeft height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidCaretLeft>
      );
    if (variant === 'caretRight')
      return (
        <SolidCaretRight height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidCaretRight>
      );
    if (variant === 'caretUp')
      return (
        <SolidCaretUp height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidCaretUp>
      );
    if (variant === 'caretDown')
      return (
        <SolidCaretDown height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidCaretDown>
      );
    if (variant === 'adIcon')
      return (
        <SolidAdIcon height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidAdIcon>
      );
    if (variant === 'bullhorn')
      return (
        <SolidBullhorn height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidBullhorn>
      );
    if (variant === 'bars')
      return (
        <SolidBars height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidBars>
      );
    if (variant === 'bell')
      return (
        <SolidBell height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidBell>
      );
    if (variant === 'signIn')
      return (
        <SolidSignIn height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidSignIn>
      );
    if (variant === 'signOut')
      return (
        <SolidSignOut height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidSignOut>
      );
    if (variant === 'analytics')
      return (
        <SolidAnalytics height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidAnalytics>
      );
    if (variant === 'chartLineUp')
      return (
        <SolidChartLineUp height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidChartLineUp>
      );
    if (variant === 'chartLineDown')
      return (
        <SolidChartLineDown
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidChartLineDown>
      );
    if (variant === 'chartNetwork')
      return (
        <SolidChartNetwork height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidChartNetwork>
      );
    if (variant === 'pieChart')
      return (
        <SolidPieChart height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidPieChart>
      );
    if (variant === 'barChart')
      return (
        <SolidBarChart height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidBarChart>
      );
    if (variant === 'poll')
      return (
        <SolidPoll height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidPoll>
      );
    if (variant === 'home')
      return (
        <SolidHome height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidHome>
      );
    if (variant === 'star')
      return (
        <SolidStar height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidStar>
      );
    if (variant === 'halfStar')
      return (
        <SolidHalfStar height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidHalfStar>
      );
    if (variant === 'altHalfStar')
      return (
        <SolidAltHalfStar height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidAltHalfStar>
      );
    if (variant === 'mousePointer')
      return (
        <SolidMousePointer height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidMousePointer>
      );
    if (variant === 'streetView')
      return (
        <SolidStreetView height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidStreetView>
      );
    if (variant === 'horizontalArrows')
      return (
        <SolidHorizontalArrows
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidHorizontalArrows>
      );
    if (variant === 'verticalArrows')
      return (
        <SolidVerticalArrows
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidVerticalArrows>
      );
    if (variant === 'sort')
      return (
        <SolidSort height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidSort>
      );
    if (variant === 'exchange')
      return (
        <SolidExchange height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidExchange>
      );
    if (variant === 'lock')
      return (
        <SolidLock height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidLock>
      );
    if (variant === 'altLock')
      return (
        <SolidAltLock height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidAltLock>
      );
    if (variant === 'unlock')
      return (
        <SolidUnlock height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidUnlock>
      );
    if (variant === 'altUnlock')
      return (
        <SolidAltUnlock height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidAltUnlock>
      );
    if (variant === 'openLock')
      return (
        <SolidOpenLock height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidOpenLock>
      );
    if (variant === 'altOpenLock')
      return (
        <SolidAltOpenLock height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidAltOpenLock>
      );
    if (variant === 'creditCard')
      return (
        <SolidCreditCard height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidCreditCard>
      );
    if (variant === 'coins')
      return (
        <SolidCoins height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidCoins>
      );
    if (variant === 'database')
      return (
        <SolidDatabase height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidDatabase>
      );
    if (variant === 'dollarSign')
      return (
        <SolidDollarSign height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidDollarSign>
      );
    if (variant === 'searchDollarSign')
      return (
        <SolidSearchDollarSign
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidSearchDollarSign>
      );
    if (variant === 'users')
      return (
        <SolidUsers height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidUsers>
      );
    if (variant === 'usersClock')
      return (
        <SolidUsersClock height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidUsersClock>
      );
    if (variant === 'usersCircle')
      return (
        <SolidUsersCircle height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidUsersCircle>
      );
    if (variant === 'user')
      return (
        <User height={height} width={width} fill={color} {...rest}>
          {children}
        </User>
      );
    if (variant === 'question')
      return (
        <SolidQuestion height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidQuestion>
      );
    if (variant === 'circleQuestion')
      return (
        <SolidCircleQuestion
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidCircleQuestion>
      );
    if (variant === 'exclamation')
      return (
        <SolidExclamation height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidExclamation>
      );
    if (variant === 'circleExclamation')
      return (
        <SolidCircleExclamation
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidCircleExclamation>
      );
    if (variant === 'triangleExclamation')
      return (
        <SolidTriangleExclamation
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidTriangleExclamation>
      );
    if (variant === 'infoCircle')
      return (
        <SolidInfoCircle height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidInfoCircle>
      );
    if (variant === 'calendar')
      return (
        <SolidCalendar height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidCalendar>
      );
    if (variant === 'dayCalendar')
      return (
        <SolidDayCalendar height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidDayCalendar>
      );
    if (variant === 'calendarClock')
      return (
        <CalendarClockIcon height={height} width={width} fill={color} {...rest}>
          {children}
        </CalendarClockIcon>
      );
    if (variant === 'camera')
      return (
        <SolidCamera height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidCamera>
      );
    if (variant === 'photoVideo')
      return (
        <SolidPhotoVideo height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidPhotoVideo>
      );
    if (variant === 'video')
      return (
        <SolidVideo height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidVideo>
      );
    if (variant === 'image')
      return (
        <SolidImage height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidImage>
      );
    if (variant === 'percent')
      return (
        <SolidPercent height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidPercent>
      );
    if (variant === 'percentage')
      return (
        <SolidPercentage height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidPercentage>
      );
    if (variant === 'sync')
      return (
        <SolidSync height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidSync>
      );
    if (variant === 'altSync')
      return (
        <SolidAltSync height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidAltSync>
      );
    if (variant === 'route')
      return (
        <SolidRoute height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidRoute>
      );
    if (variant === 'globe')
      return (
        <SolidGlobe height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidGlobe>
      );
    if (variant === 'map')
      return (
        <SolidMap height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidMap>
      );
    if (variant === 'mapMarker')
      return (
        <SolidMapMarker height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidMapMarker>
      );
    if (variant === 'mapPin')
      return (
        <SolidMapPin height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidMapPin>
      );
    if (variant === 'mapSigns')
      return (
        <SolidMapSigns height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidMapSigns>
      );
    if (variant === 'location')
      return (
        <SolidLocation height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidLocation>
      );
    if (variant === 'directions')
      return (
        <SolidDirections height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidDirections>
      );
    if (variant === 'check')
      return (
        <SolidCheck height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidCheck>
      );
    if (variant === 'circleCheck')
      return (
        <SolidCircleCheck height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidCircleCheck>
      );
    if (variant === 'doubleCheck')
      return (
        <SolidDoubleCheck height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidDoubleCheck>
      );
    if (variant === 'badgeCheck')
      return (
        <SolidBadgeCheck height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidBadgeCheck>
      );
    if (variant === 'rocketLaunch')
      return (
        <SolidRocketLaunch height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidRocketLaunch>
      );
    if (variant === 'circleX')
      return (
        <SolidCircleX height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidCircleX>
      );
    if (variant === 'eye')
      return (
        <SolidEye height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidEye>
      );
    if (variant === 'eyeSlash')
      return (
        <SolidEyeSlash height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidEyeSlash>
      );
    if (variant === 'toggleOn')
      return (
        <SolidToggleOn height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidToggleOn>
      );
    if (variant === 'toggleOff')
      return (
        <SolidToggleOff height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidToggleOff>
      );
    if (variant === 'plus')
      return (
        <SolidPlus height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidPlus>
      );
    if (variant === 'circlePlus')
      return (
        <SolidCirclePlus height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidCirclePlus>
      );
    if (variant === 'phone')
      return (
        <SolidPhone height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidPhone>
      );
    if (variant === 'altPhone')
      return (
        <SolidAltPhone height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidAltPhone>
      );
    if (variant === 'link')
      return (
        <SolidLink height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidLink>
      );
    if (variant === 'cog')
      return (
        <SolidCog height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidCog>
      );
    if (variant === 'pen')
      return (
        <SolidPen height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidPen>
      );
    if (variant === 'trash')
      return (
        <SolidTrash height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidTrash>
      );
    if (variant === 'altTrash')
      return (
        <SolidAltTrash height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidAltTrash>
      );
    if (variant === 'reply')
      return (
        <SolidReply height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidReply>
      );
    if (variant === 'edit')
      return (
        <SolidEdit height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidEdit>
      );
    if (variant === 'filter')
      return (
        <SolidFilter height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidFilter>
      );
    if (variant === 'externalLink')
      return (
        <SolidExternalLink height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidExternalLink>
      );
    if (variant === 'download')
      return (
        <SolidDownload height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidDownload>
      );
    if (variant === 'search')
      return (
        <SolidSearch height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidSearch>
      );
    if (variant === 'searchPlus')
      return (
        <SolidSearchPlus height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidSearchPlus>
      );
    if (variant === 'clock')
      return (
        <SolidClock height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidClock>
      );
    if (variant === 'share')
      return (
        <SolidShare height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidShare>
      );
    if (variant === 'envelope')
      return (
        <SolidEnvelope height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidEnvelope>
      );
    if (variant === 'envelopeOpen')
      return (
        <SolidEnvelopeOpen height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidEnvelopeOpen>
      );
    if (variant === 'envelopeOpenText')
      return (
        <SolidEnvelopeOpenText
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidEnvelopeOpenText>
      );
    if (variant === 'bulkMail')
      return (
        <SolidMailBulk height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidMailBulk>
      );
    if (variant === 'save')
      return (
        <SolidSave height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidSave>
      );
    if (variant === 'folderOpen')
      return (
        <SolidFolderOpen height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidFolderOpen>
      );
    if (variant === 'comments')
      return (
        <SolidComments height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidComments>
      );
    if (variant === 'cloudUpload')
      return (
        <SolidCloudUpload height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidCloudUpload>
      );
    if (variant === 'cloudDownload')
      return (
        <SolidCloudDownload
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidCloudDownload>
      );
    if (variant === 'task')
      return (
        <SolidTask height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidTask>
      );
    if (variant === 'altTask')
      return (
        <SolidAltTask height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidAltTask>
      );
    if (variant === 'landmark')
      return (
        <SolidLandmark height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidLandmark>
      );
    if (variant === 'history')
      return (
        <SolidHistory height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidHistory>
      );
    if (variant === 'phoneRotary')
      return (
        <SolidPhoneRotary height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidPhoneRotary>
      );
    if (variant === 'phoneOffice')
      return (
        <SolidPhoneOffice height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidPhoneOffice>
      );
    if (variant === 'phoneLaptop')
      return (
        <SolidPhoneLaptop height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidPhoneLaptop>
      );
    if (variant === 'voicemail')
      return (
        <SolidVoicemail height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidVoicemail>
      );
    if (variant === 'mobile')
      return (
        <SolidMobile height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidMobile>
      );
    if (variant === 'mobileAndroid')
      return (
        <SolidMobileAndroid
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </SolidMobileAndroid>
      );
    if (variant === 'reaction')
      return (
        <SolidReaction height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidReaction>
      );
    if (variant === 'piggyBank')
      return (
        <SolidPiggyBank height={height} width={width} fill={color} {...rest}>
          {children}
        </SolidPiggyBank>
      );
  }

  if (type === 'regular') {
    if (variant === 'briefcase') {
      return (
        <RegularBriefcase
          height={height}
          width={width}
          fill={color}
          {...rest}
        />
      );
    }
    if (variant === 'memoCheck') {
      return (
        <RegularMemoCheck
          height={height}
          width={width}
          fill={color}
          {...rest}
        />
      );
    }
    if (variant === 'heart')
      return (
        <RegularHeart height={height} width={width} fill={color} {...rest} />
      );
    if (variant === 'reaction')
      return (
        <RegularReaction height={height} width={width} fill={color} {...rest} />
      );
    if (variant === 'caretCircleLeft')
      return (
        <RegularCircleCaretLeft
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleCaretLeft>
      );
    if (variant === 'caretCircleRight')
      return (
        <RegularCircleCaretRight
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleCaretRight>
      );
    if (variant === 'caretCircleUp')
      return (
        <RegularCircleCaretUp
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleCaretUp>
      );
    if (variant === 'caretCircleDown')
      return (
        <RegularCircleCaretDown
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleCaretDown>
      );
    if (variant === 'altArrowCircleLeft')
      return (
        <RegularCircleAltArrowLeft
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleAltArrowLeft>
      );
    if (variant === 'altArrowCircleRight')
      return (
        <RegularCircleAltArrowRight
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleAltArrowRight>
      );
    if (variant === 'altArrowCircleUp')
      return (
        <RegularCircleAltArrowUp
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleAltArrowUp>
      );
    if (variant === 'altArrowCircleDown')
      return (
        <RegularCircleAltArrowDown
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleAltArrowDown>
      );
    if (variant === 'arrowCircleLeft')
      return (
        <RegularCircleArrowLeft
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleArrowLeft>
      );
    if (variant === 'arrowCircleRight')
      return (
        <RegularCircleArrowRight
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleArrowRight>
      );
    if (variant === 'arrowCircleUp')
      return (
        <RegularCircleArrowUp
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleArrowUp>
      );
    if (variant === 'arrowCircleDown')
      return (
        <RegularCircleArrowDown
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleArrowDown>
      );
    if (variant === 'chevronCircleLeft')
      return (
        <RegularCircleChevronLeft
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleChevronLeft>
      );
    if (variant === 'chevronCircleRight')
      return (
        <RegularCircleChevronRight
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleChevronRight>
      );
    if (variant === 'chevronCircleUp')
      return (
        <RegularCircleChevronUp
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleChevronUp>
      );
    if (variant === 'chevronCircleDown')
      return (
        <RegularCircleChevronDown
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleChevronDown>
      );
    if (variant === 'chevronCircleLeft')
      return (
        <RegularCircleChevronLeft
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleChevronLeft>
      );
    if (variant === 'chevronCircleRight')
      return (
        <RegularCircleChevronRight
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleChevronRight>
      );
    if (variant === 'chevronLeft')
      return (
        <RegularChevronLeft
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularChevronLeft>
      );
    if (variant === 'chevronRight')
      return (
        <RegularChevronRight
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularChevronRight>
      );
    if (variant === 'chevronUp')
      return (
        <RegularChevronUp height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularChevronUp>
      );
    if (variant === 'chevronDown')
      return (
        <RegularChevronDown
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularChevronDown>
      );
    if (variant === 'arrowLeft')
      return (
        <RegularArrowLeft height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularArrowLeft>
      );
    if (variant === 'arrowRight')
      return (
        <RegularArrowRight height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularArrowRight>
      );
    if (variant === 'arrowUp')
      return (
        <RegularArrowUp height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularArrowUp>
      );
    if (variant === 'arrowDown')
      return (
        <RegularArrowDown height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularArrowDown>
      );
    if (variant === 'longArrowLeft')
      return (
        <RegularLongArrowLeft
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularLongArrowLeft>
      );
    if (variant === 'longArrowRight')
      return (
        <RegularLongArrowRight
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularLongArrowRight>
      );
    if (variant === 'longArrowUp')
      return (
        <RegularLongArrowUp
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularLongArrowUp>
      );
    if (variant === 'longArrowDown')
      return (
        <RegularLongArrowDown
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularLongArrowDown>
      );
    if (variant === 'longAltArrowLeft')
      return (
        <RegularLongAltArrowLeft
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularLongAltArrowLeft>
      );
    if (variant === 'longAltArrowRight')
      return (
        <RegularLongAltArrowRight
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularLongAltArrowRight>
      );
    if (variant === 'longAltArrowUp')
      return (
        <RegularLongAltArrowUp
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularLongAltArrowUp>
      );
    if (variant === 'longAltArrowDown')
      return (
        <RegularLongAltArrowDown
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularLongAltArrowDown>
      );
    if (variant === 'adIcon')
      return (
        <RegularAdIcon height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularAdIcon>
      );
    if (variant === 'bullhorn')
      return (
        <RegularBullhorn height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularBullhorn>
      );
    if (variant === 'bars')
      return (
        <RegularBars height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularBars>
      );
    if (variant === 'bell')
      return (
        <RegularBell height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularBell>
      );
    if (variant === 'signIn')
      return (
        <RegularSignIn height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularSignIn>
      );
    if (variant === 'signOut')
      return (
        <RegularSignOut height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularSignOut>
      );
    if (variant === 'signInAlt')
      return (
        <RegularAltSignIn height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularAltSignIn>
      );
    if (variant === 'signOutAlt')
      return (
        <RegularAltSignOut height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularAltSignOut>
      );
    if (variant === 'analytics')
      return (
        <RegularAnalytics height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularAnalytics>
      );
    if (variant === 'chartLineUp')
      return (
        <RegularChartLineUp
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularChartLineUp>
      );
    if (variant === 'chartLineDown')
      return (
        <RegularChartLineDown
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularChartLineDown>
      );
    if (variant === 'chartNetwork')
      return (
        <RegularChartNetwork
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularChartNetwork>
      );
    if (variant === 'pieChart')
      return (
        <RegularPieChart height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularPieChart>
      );
    if (variant === 'barChart')
      return (
        <RegularBarChart height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularBarChart>
      );
    if (variant === 'poll')
      return (
        <RegularPoll height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularPoll>
      );
    if (variant === 'home')
      return (
        <RegularHome height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularHome>
      );
    if (variant === 'star')
      return (
        <RegularStar height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularStar>
      );
    if (variant === 'halfStar')
      return (
        <RegularHalfStar height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularHalfStar>
      );
    if (variant === 'streetView')
      return (
        <RegularStreetView height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularStreetView>
      );
    if (variant === 'bullseyePointer')
      return (
        <RegularBullseyePointer
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularBullseyePointer>
      );
    if (variant === 'horizontalArrows')
      return (
        <RegularHorizontalArrows
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularHorizontalArrows>
      );
    if (variant === 'verticalArrows')
      return (
        <RegularVerticalArrows
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularVerticalArrows>
      );
    if (variant === 'sort')
      return (
        <RegularSort height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularSort>
      );
    if (variant === 'exchange')
      return (
        <RegularExchange height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularExchange>
      );
    if (variant === 'horizontalAltArrows')
      return (
        <RegularAltHorizontalArrows
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularAltHorizontalArrows>
      );
    if (variant === 'verticalAltArrows')
      return (
        <RegularAltVerticalArrows
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularAltVerticalArrows>
      );
    if (variant === 'sortDown')
      return (
        <RegularSortDown height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularSortDown>
      );
    if (variant === 'altSortDown')
      return (
        <RegularAltSortDown
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularAltSortDown>
      );
    if (variant === 'sortUp')
      return (
        <RegularSortUp height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularSortUp>
      );
    if (variant === 'altSortUp')
      return (
        <RegularAltSortUp height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularAltSortUp>
      );
    if (variant === 'lock')
      return (
        <RegularLock height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularLock>
      );
    if (variant === 'altLock')
      return (
        <RegularAltLock height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularAltLock>
      );
    if (variant === 'unlock')
      return (
        <RegularUnlock height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularUnlock>
      );
    if (variant === 'altUnlock')
      return (
        <RegularAltUnlock height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularAltUnlock>
      );
    if (variant === 'openLock')
      return (
        <RegularOpenLock height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularOpenLock>
      );
    if (variant === 'altOpenLock')
      return (
        <RegularAltOpenLock
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularAltOpenLock>
      );
    if (variant === 'creditCard')
      return (
        <RegularCreditCard height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularCreditCard>
      );
    if (variant === 'coins')
      return (
        <RegularCoins height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularCoins>
      );
    if (variant === 'database')
      return (
        <RegularDatabase height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularDatabase>
      );
    if (variant === 'bill')
      return (
        <RegularBill height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularBill>
      );
    if (variant === 'dollarSign')
      return (
        <RegularDollarSign height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularDollarSign>
      );
    if (variant === 'circleDollarSign')
      return (
        <RegularCircleDollarSign
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleDollarSign>
      );
    if (variant === 'searchDollarSign')
      return (
        <RegularSearchDollarSign
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularSearchDollarSign>
      );
    if (variant === 'usersCircle')
      return (
        <RegularUsersCircle
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularUsersCircle>
      );
    if (variant === 'users')
      return (
        <RegularUsers height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularUsers>
      );
    if (variant === 'usersChart')
      return (
        <RegularUsersChart height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularUsersChart>
      );
    if (variant === 'usersChalkboard')
      return (
        <RegularUsersChalkboard
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularUsersChalkboard>
      );
    if (variant === 'user')
      return (
        <RegularUser height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularUser>
      );
    if (variant === 'altUser')
      return (
        <RegularAltUser height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularAltUser>
      );
    if (variant === 'horizontalEllipsis')
      return (
        <HorizontalEllipsis
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </HorizontalEllipsis>
      );
    if (variant === 'verticalEllipsis')
      return (
        <VerticalEllipsis height={height} width={width} fill={color} {...rest}>
          {children}
        </VerticalEllipsis>
      );
    if (variant === 'at')
      return (
        <RegularAt height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularAt>
      );
    if (variant === 'circleQuestion')
      return (
        <RegularCircleQuestion
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleQuestion>
      );
    if (variant === 'triangleExclamation')
      return (
        <RegularTriangleExclamation
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularTriangleExclamation>
      );
    if (variant === 'circleExclamation')
      return (
        <RegularCircleExclamation
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleExclamation>
      );
    if (variant === 'infoCircle')
      return (
        <RegularInfoCircle height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularInfoCircle>
      );
    if (variant === 'calendar')
      return (
        <RegularCalendar height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularCalendar>
      );
    if (variant === 'calendarClock')
      return (
        <RegularClockCalendar
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularClockCalendar>
      );
    if (variant === 'camera')
      return (
        <RegularCamera height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularCamera>
      );
    if (variant === 'photoVideo')
      return (
        <RegularPhotoVideo height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularPhotoVideo>
      );
    if (variant === 'video')
      return (
        <RegularVideo height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularVideo>
      );
    if (variant === 'image')
      return (
        <RegularImage height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularImage>
      );
    if (variant === 'altImage')
      return (
        <RegularAltImage height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularAltImage>
      );
    if (variant === 'images')
      return (
        <RegularImages height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularImages>
      );
    if (variant === 'percent')
      return (
        <RegularPercent height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularPercent>
      );
    if (variant === 'percentage')
      return (
        <RegularPercentage height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularPercentage>
      );
    if (variant === 'sync')
      return (
        <RegularSync height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularSync>
      );
    if (variant === 'altSync')
      return (
        <RegularAltSync height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularAltSync>
      );
    if (variant === 'route')
      return (
        <RegularRoute height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularRoute>
      );
    if (variant === 'globe')
      return (
        <RegularGlobe height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularGlobe>
      );
    if (variant === 'map')
      return (
        <RegularMap height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularMap>
      );
    if (variant === 'mapMarker')
      return (
        <RegularMapMarker height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularMapMarker>
      );
    if (variant === 'mapPin')
      return (
        <RegularMapPin height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularMapPin>
      );
    if (variant === 'mapSigns')
      return (
        <RegularMapSigns height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularMapSigns>
      );
    if (variant === 'location')
      return (
        <RegularLocation height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularLocation>
      );
    if (variant === 'directions')
      return (
        <RegularDirections height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularDirections>
      );
    if (variant === 'check')
      return (
        <RegularCheck height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularCheck>
      );
    if (variant === 'circleCheck')
      return (
        <RegularCircleCheck
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCircleCheck>
      );
    if (variant === 'doubleCheck')
      return (
        <RegularDoubleCheck
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularDoubleCheck>
      );
    if (variant === 'checkSquare')
      return (
        <RegularCheckSquare
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCheckSquare>
      );
    if (variant === 'minusSquare')
      return (
        <RegularMinusSquare
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularMinusSquare>
      );
    if (variant === 'square')
      return (
        <RegularSquare height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularSquare>
      );
    if (variant === 'circleX')
      return (
        <RegularCircleX height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularCircleX>
      );
    if (variant === 'x')
      return (
        <RegularX height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularX>
      );
    if (variant === 'eye')
      return (
        <RegularEye height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularEye>
      );
    if (variant === 'eyeSlash')
      return (
        <RegularEyeSlash height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularEyeSlash>
      );
    if (variant === 'toggleOn')
      return (
        <RegularToggleOn height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularToggleOn>
      );
    if (variant === 'toggleOff')
      return (
        <RegularToggleOff height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularToggleOff>
      );
    if (variant === 'plus')
      return (
        <RegularPlus height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularPlus>
      );
    if (variant === 'circlePlus')
      return (
        <RegularCirclePlus height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularCirclePlus>
      );
    if (variant === 'phone')
      return (
        <RegularPhone height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularPhone>
      );
    if (variant === 'altPhone')
      return (
        <RegularAltPhone height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularAltPhone>
      );
    if (variant === 'link')
      return (
        <RegularLink height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularLink>
      );
    if (variant === 'cog')
      return (
        <RegularCog height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularCog>
      );
    if (variant === 'pen')
      return (
        <RegularPen height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularPen>
      );
    if (variant === 'trash')
      return (
        <RegularTrash height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularTrash>
      );
    if (variant === 'altTrash')
      return (
        <RegularAltTrash height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularAltTrash>
      );
    if (variant === 'reply')
      return (
        <RegularReply height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularReply>
      );
    if (variant === 'edit')
      return (
        <RegularEdit height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularEdit>
      );
    if (variant === 'filter')
      return (
        <RegularFilter height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularFilter>
      );
    if (variant === 'externalLink')
      return (
        <RegularExternalLink
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularExternalLink>
      );
    if (variant === 'altExternalLink')
      return (
        <RegularAltExternalLink
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularAltExternalLink>
      );
    if (variant === 'download')
      return (
        <RegularDownload height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularDownload>
      );
    if (variant === 'search')
      return (
        <RegularSearch height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularSearch>
      );
    if (variant === 'searchPlus')
      return (
        <RegularSearchPlus height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularSearchPlus>
      );
    if (variant === 'clock')
      return (
        <RegularClock height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularClock>
      );
    if (variant === 'share')
      return (
        <RegularShare height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularShare>
      );
    if (variant === 'envelope')
      return (
        <RegularEnvelope height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularEnvelope>
      );
    if (variant === 'envelopeOpen')
      return (
        <RegularEnvelopeOpen
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularEnvelopeOpen>
      );
    if (variant === 'envelopeOpenText')
      return (
        <RegularEnvelopeOpenText
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularEnvelopeOpenText>
      );
    if (variant === 'bulkMail')
      return (
        <RegularMailBulk height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularMailBulk>
      );
    if (variant === 'save')
      return (
        <RegularSave height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularSave>
      );
    if (variant === 'folderOpen')
      return (
        <RegularFolderOpen height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularFolderOpen>
      );
    if (variant === 'comments')
      return (
        <RegularComments height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularComments>
      );
    if (variant === 'altComments')
      return (
        <RegularAltComments
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularAltComments>
      );
    if (variant === 'altComment')
      return (
        <RegularAltComment height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularAltComment>
      );
    if (variant === 'comment')
      return (
        <RegularComment height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularComment>
      );
    if (variant === 'cloudUpload')
      return (
        <RegularCloudUpload
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCloudUpload>
      );
    if (variant === 'cloudDownload')
      return (
        <RegularCloudDownload
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularCloudDownload>
      );
    if (variant === 'list')
      return (
        <RegularList height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularList>
      );
    if (variant === 'file')
      return (
        <RegularFile height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularFile>
      );
    if (variant === 'fileExport')
      return (
        <RegularFileExport height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularFileExport>
      );
    if (variant === 'fileImport')
      return (
        <RegularFileImport height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularFileImport>
      );
    if (variant === 'fileSignature')
      return (
        <RegularFileSignature
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularFileSignature>
      );
    if (variant === 'fileInvoiceDollar')
      return (
        <RegularFileInvoiceDollar
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularFileInvoiceDollar>
      );
    if (variant === 'altFile')
      return (
        <RegularAltFile height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularAltFile>
      );
    if (variant === 'landmark')
      return (
        <RegularLandmark height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularLandmark>
      );
    if (variant === 'history')
      return (
        <RegularHistory height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularHistory>
      );
    if (variant === 'phoneRotary')
      return (
        <RegularPhoneRotary
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularPhoneRotary>
      );
    if (variant === 'phoneOffice')
      return (
        <RegularPhoneOffice
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularPhoneOffice>
      );
    if (variant === 'phoneLaptop')
      return (
        <RegularPhoneLaptop
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularPhoneLaptop>
      );
    if (variant === 'voicemail')
      return (
        <RegularVoicemail height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularVoicemail>
      );
    if (variant === 'mobile')
      return (
        <RegularMobile height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularMobile>
      );
    if (variant === 'mobileAndroid')
      return (
        <RegularMobileAndroid
          height={height}
          width={width}
          fill={color}
          {...rest}
        >
          {children}
        </RegularMobileAndroid>
      );
    if (variant === 'award')
      return (
        <RegularAward height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularAward>
      );
    if (variant === 'handshake')
      return (
        <RegularHandshake height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularHandshake>
      );
    if (variant === 'reaction')
      return (
        <RegularReaction height={height} width={width} fill={color} {...rest}>
          {children}
        </RegularReaction>
      );
    if (variant === 'android')
      return (
        <Android height={height} width={width} fill={color} {...rest}>
          {children}
        </Android>
      );
    if (variant === 'desktop')
      return (
        <Desktop height={height} width={width} fill={color} {...rest}>
          {children}
        </Desktop>
      );
    if (variant === 'wifi')
      return (
        <Wifi height={height} width={width} fill={color} {...rest}>
          {children}
        </Wifi>
      );
    if (variant === 'bluetooth')
      return (
        <Bluetooth height={height} width={width} fill={color} {...rest}>
          {children}
        </Bluetooth>
      );
    if (variant === 'thryvlogo')
      return (
        <ThryvLogo height={height} width={width} fill={color} {...rest}>
          {children}
        </ThryvLogo>
      );
    if (variant === 'thryvpaylogo')
      return (
        <ThryvpayLogo height={height} width={width} fill={color} {...rest}>
          {children}
        </ThryvpayLogo>
      );
  }

  return <div>Invalid properties</div>;
};
